import script from "./userCenter.vue?vue&type=script&setup=true&lang=js"
export * from "./userCenter.vue?vue&type=script&setup=true&lang=js"

import "./userCenter.vue?vue&type=style&index=0&id=5a6d1122&lang=less"
import "./userCenter.vue?vue&type=style&index=1&id=5a6d1122&lang=less&scoped=true"

import exportComponent from "D:\\CODE\\joyjobs_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a6d1122"]])

export default __exports__